import React from 'react';
import { NavDropdown } from 'react-bootstrap';

import "./DashboardsNav.css";

class DashboardsNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dashboards: []
        };
    }

	async componentDidMount() {
        // let url = "http://static.smartstake.io.s3.amazonaws.com/resources/dashboards.json";
        let url = "https://static.smartstake.io/resources/dashboards.json";
        // fetch(url, {mode: 'cors'})
    
        fetch(url, {referrerPolicy: 'no-referrer'})
          .then(this.handleErrors)
          .then(res => res.json())
          .then((data) => {
            let ssDashboards = data["ssDashboards"];
    
            if (ssDashboards && ssDashboards.length != 0) {
                this.setState({dashboards: ssDashboards});
            }
          }).catch(error => console.log(error))
    }
    

  render() {

    return (
        <NavDropdown 
            title={<span className="customNavLink">Dashboards</span>} id="nav-dropdown">
            {this.state.dashboards.map(dashboard => (
                <NavDropdown.Item className="customNavDropdownLink" href={dashboard.website}>{dashboard.name}</NavDropdown.Item>
            ))}
        </NavDropdown>
    );
  }

}

export default DashboardsNav;



// WEBPACK FOOTER //
// ./src/base/DashboardsNav.js